"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CartItem = require("./CartItem");

var _CartItem2 = _interopRequireDefault(_CartItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherOrderCart = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VoucherOrderCart, _Component);

  function VoucherOrderCart() {
    (0, _classCallCheck3.default)(this, VoucherOrderCart);
    return (0, _possibleConstructorReturn3.default)(this, (VoucherOrderCart.__proto__ || (0, _getPrototypeOf2.default)(VoucherOrderCart)).apply(this, arguments));
  }

  (0, _createClass3.default)(VoucherOrderCart, [{
    key: "render",
    value: function render() {
      if (!this.props.cart || !this.props.cart.length) {
        return this.renderEmptyMessage();
      }
      return this.renderCart();
    }
  }, {
    key: "renderEmptyMessage",
    value: function renderEmptyMessage() {
      return _react2.default.createElement(
        "div",
        { className: "voucher-order-cart" },
        _react2.default.createElement(
          "p",
          null,
          "Ostoskori on tyhj\xE4."
        )
      );
    }
  }, {
    key: "renderCart",
    value: function renderCart() {
      return _react2.default.createElement(
        "table",
        { className: "table voucher-order-cart" },
        _react2.default.createElement(
          "thead",
          null,
          _react2.default.createElement(
            "tr",
            null,
            _react2.default.createElement(
              "th",
              null,
              "Lipuke:"
            ),
            _react2.default.createElement(
              "th",
              null,
              "M\xE4\xE4r\xE4:"
            ),
            _react2.default.createElement(
              "th",
              null,
              "Hinta:"
            ),
            _react2.default.createElement("th", null)
          )
        ),
        _react2.default.createElement(
          "tbody",
          null,
          this.renderItems()
        )
      );
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _props = this.props,
          cart = _props.cart,
          removeCartItem = _props.removeCartItem,
          updateQuantity = _props.updateQuantity;


      if (!cart || !cart.length) {
        return null;
      }
      return cart.map(function (item) {
        return _react2.default.createElement(_CartItem2.default, {
          key: item.id,
          item: item,
          removeCartItem: removeCartItem,
          updateQuantity: updateQuantity
        });
      });
    }
  }]);
  return VoucherOrderCart;
}(_react.Component), _class.propTypes = {
  cart: _react.PropTypes.array,
  removeCartItem: _react.PropTypes.func.isRequired,
  updateQuantity: _react.PropTypes.func.isRequired
}, _temp);
exports.default = VoucherOrderCart;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/vouchers/VoucherOrderCart.js
 ** module id = 1200
 ** module chunks = 0
 **/